export enum MassUploadSteps {
  UPLOAD = 'UPLOAD',
  REVIEW = 'REVIEW'
}
